import React from 'react';
import { ButtonGroup, DropdownButton, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import _ from 'underscore';
import * as Fi from 'react-icons/fi';
import DispatchForm from '../dispatch/form';
import { Table } from 'services/action';
import { FormUpdatePricing } from '../form/price';
import {isNotClient} from 'utilities/common'

const initialState = {
  privilege: null,
  showDispatch: false,
  showPrice: false,
};

const Action = ({ data }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const Session = useSelector((state) => state.Auth?.session);
  const StateTable = useSelector((state) => state?.Table?.data['order']);

  const [{ privilege, showDispatch, showPrice }, setState] =
    React.useState(initialState);

  const $getPriviledge = async () => {
    const payload = {};

    const delivery = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.delivery',
    });

    const manifest = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.manifest',
    });

    const pricing = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.pricing',
    });

    if (delivery) {
      payload.delivery = delivery;
    }

    if (pricing) {
      payload.pricing = pricing;
    }

    if (manifest) {
      payload.manifest = manifest;
    }

    setState((prevState) => ({ ...prevState, privilege: payload }));
  };

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      showDispatch: false,
      showPrice: false,
    }));
  };

  React.useEffect(() => {
    $getPriviledge();
  }, []);

  if (isNotClient(Session?.client?.id, data?.client?.id)) {
    return (
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id={`tooltip-top`}>Detil</Tooltip>}
      >
        <Link
          className="btn btn-light px-2"
          role="button"
          to={`/order/${data?.id}`}
        >
          <Fi.FiArrowRight />
        </Link>
      </OverlayTrigger>
    );
  }

  return (
    <>
      <DropdownButton
        as={ButtonGroup}
        variant="transparent"
        size="md"
        className="no-carret tbl-action"
        title={<Fi.FiMoreVertical size={13} color="gray" />}
      >
        <Link
          className="dropdown-item d-flex align-items-center"
          role="button"
          to={`/order/${data?.id}`}
        >
          <Fi.FiClipboard size={15} color="#202020" className="me-2" />
          Lihat Detil
        </Link>

        {data?.document_status !== 'voided' && (
          <Link
            className="dropdown-item d-flex align-items-center"
            role="button"
            to={`/print/order/${data?.id}`}
            target="_blank"
          >
            <Fi.FiPrinter size={15} color="#202020" className="me-2" />
            Print Order
          </Link>
        )}

        {data?.document_status === 'new' && (
          <>
            {data?.type === 'ftl' &&
              (!Session?.privileges ||
                privilege?.manifest?.action === 'manage') && (
                <button
                  className="dropdown-item d-flex align-items-center"
                  onClick={() =>
                    setState((prevState) => ({
                      ...prevState,
                      showDispatch: true,
                    }))
                  }
                >
                  <Fi.FiGitMerge size={15} color="#202020" className="me-2" />
                  Dispatch
                </button>
              )}
            {(!Session?.privileges ||
              privilege?.delivery?.action === 'manage') && data?.manifest_id === '' && (
              <Link
                className="dropdown-item d-flex align-items-center"
                role="button"
                to={`/order/${data?.id}/update`}
              >
                <Fi.FiEdit size={15} color="#202020" className="me-2" />
                Perbaharui
              </Link>
            )}
          </>
        )}

        {data?.type === 'ftl' &&
        data?.document_status !== 'voided' &&
        (!Session?.privileges || privilege?.pricing?.action === 'manage') ? (
          <div
            className="dropdown-item d-flex align-items-center cursor-pointer"
            onClick={() => {
              setState((prevState) => ({ ...prevState, showPrice: true }));
            }}
          >
            <Fi.FiCreditCard size={15} color="#202020" className="me-2" />
            Perbaharui Harga
          </div>
        ) : null}
      </DropdownButton>

      {/* modal update harga */}
      <Modal
        show={showPrice}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-primary" />
          <h3 className="text-center mb-3">Update harga</h3>
          <FormUpdatePricing
            data={data}
            onSubmit={() => {
              Dispatch(Table.$reload('order', StateTable));
              $handleClose();
            }}
          />
        </Modal.Body>
      </Modal>

      {/* modal showDispatch */}
      <Modal
        show={showDispatch}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="small"
      >
        <Modal.Header className="text-center d-block p-0" closeButton>
          <div className="py-3">
            <div className="fw-bold fs-6">Dispatch Order</div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <DispatchForm
            data={data}
            onCreate={() => History.push(`/order/${data?.id}`)}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Action;
